module.exports = __webpack_public_path__ + "img/12.fd13836f.png";